import { render, staticRenderFns } from "./formSubmit.vue?vue&type=template&id=4a7df3de&scoped=true&"
import script from "./formSubmit.vue?vue&type=script&lang=js&"
export * from "./formSubmit.vue?vue&type=script&lang=js&"
import style0 from "./formSubmit.vue?vue&type=style&index=0&id=4a7df3de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7df3de",
  null
  
)

export default component.exports